export default {
  data: () => ({
    message: 'A',
    counter: 0
  })
}
